import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconOctopus({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none">
				<path
					fill="#FFF"
					d="M9.256 12.178a.33.33 0 0 1-.185-.056c-.077-.051-1.908-1.295-1.908-4.676 0-3.316 2.91-4.192 4.458-4.192a.34.34 0 0 1 .339.342.34.34 0 0 1-.339.342 4.6 4.6 0 0 0-2.31.66c-.976.616-1.468 1.575-1.468 2.85 0 2.989 1.537 4.06 1.603 4.105a.343.343 0 0 1-.188.627z"
				/>
				<path
					fill="#FFF"
					d="M14.03 12.18a.344.344 0 0 1-.188-.628c.072-.048 1.603-1.122 1.603-4.106 0-1.274-.494-2.234-1.47-2.848a4.6 4.6 0 0 0-2.31-.66.34.34 0 0 1-.339-.342.34.34 0 0 1 .339-.342c1.542 0 4.458.876 4.458 4.195 0 3.382-1.831 4.627-1.908 4.678a.33.33 0 0 1-.185.053m-8.384 1.894a.344.344 0 0 1-.341-.347.82.82 0 0 0-.812-.825.82.82 0 0 0-.811.825.344.344 0 0 1-.341.347.344.344 0 0 1-.341-.347 1.506 1.506 0 0 1 1.493-1.457c.801 0 1.46.643 1.494 1.457a.344.344 0 0 1-.341.347m1.292 3.156a1.483 1.483 0 0 1-1.494-1.468c0-.186.152-.336.34-.336s.342.15.342.336c0 .44.363.798.81.798a.805.805 0 0 0 .812-.798c0-.186.153-.336.341-.336s.341.15.341.336a1.483 1.483 0 0 1-1.492 1.468"
				/>
				<path
					fill="#FFF"
					d="M5.625 16.148a.357.357 0 0 1-.362-.351v-2.094c0-.194.162-.35.362-.35s.362.156.362.35v2.094a.35.35 0 0 1-.106.248.37.37 0 0 1-.256.103m2.436-2.615a.355.355 0 0 1-.355-.354c.002-.9.733-1.628 1.636-1.63a.355.355 0 1 1 0 .708.926.926 0 0 0-.928.922.355.355 0 0 1-.353.354"
				/>
				<path
					fill="#FFF"
					d="M8.068 16.148a.354.354 0 0 1-.362-.346v-2.645c0-.19.162-.346.362-.346s.362.155.362.346v2.645c0 .19-.162.346-.362.346m.074 3.786a.344.344 0 0 1-.345-.342c0-.19.154-.343.345-.343a1.054 1.054 0 0 0 1.045-1.046c0-.189.155-.342.346-.342s.345.153.345.342a1.74 1.74 0 0 1-1.736 1.731m1.469-5.229a.356.356 0 0 1-.366-.354c.001-.9.732-1.628 1.635-1.63a.355.355 0 1 1 0 .708.926.926 0 0 0-.925.922.355.355 0 0 1-.344.354"
				/>
				<path
					fill="#FFF"
					d="M9.618 18.492a.37.37 0 0 1-.263-.098.34.34 0 0 1-.11-.248v-3.817c0-.19.162-.345.362-.345s.362.154.362.345v3.817c0 .187-.156.34-.351.346M8.872 23a.35.35 0 1 1 0-.7 1.84 1.84 0 0 0 1.843-1.836.35.35 0 0 1 .702 0A2.543 2.543 0 0 1 8.872 23m3.47-7.484a.344.344 0 0 1-.342-.345.314.314 0 0 0-.312-.316.314.314 0 0 0-.312.316c0 .19-.153.345-.342.345a.344.344 0 0 1-.341-.345c0-.556.445-1.007.995-1.007s.996.45.996 1.007c0 .091-.036.18-.1.244a.34.34 0 0 1-.242.101"
				/>
				<path
					fill="#FFF"
					d="M11.055 20.926a.354.354 0 0 1-.362-.346v-5.53c0-.19.162-.345.362-.345s.362.155.362.346v5.53a.354.354 0 0 1-.362.345m8.89-6.852a.344.344 0 0 1-.341-.347.82.82 0 0 0-.812-.825.82.82 0 0 0-.81.825.344.344 0 0 1-.342.347.344.344 0 0 1-.34-.347 1.506 1.506 0 0 1 1.492-1.457c.801 0 1.46.643 1.494 1.457a.344.344 0 0 1-.341.347M16.44 17.23a1.483 1.483 0 0 1-1.494-1.468c0-.186.153-.336.341-.336s.341.15.341.336c0 .44.363.798.811.798a.805.805 0 0 0 .812-.798c0-.186.152-.336.34-.336s.342.15.342.336a1.483 1.483 0 0 1-1.492 1.468z"
				/>
				<path
					fill="#FFF"
					d="M17.661 16.057a.357.357 0 0 1-.362-.35v-2.094c0-.194.162-.35.362-.35s.362.156.362.35v2.094c0 .193-.162.35-.362.35m-2.346-2.524a.355.355 0 0 1-.356-.354.926.926 0 0 0-.924-.922.356.356 0 0 1-.308-.53.36.36 0 0 1 .308-.178c.902.002 1.634.73 1.635 1.63a.353.353 0 0 1-.355.354"
				/>
				<path
					fill="#FFF"
					d="M15.308 16.148a.354.354 0 0 1-.362-.346v-2.645c0-.19.162-.346.362-.346s.362.155.362.346v2.645c0 .19-.162.346-.362.346m-.073 3.778a1.737 1.737 0 0 1-1.737-1.724c0-.189.155-.341.345-.341s.345.152.345.34a1.05 1.05 0 0 0 1.047 1.051c.19 0 .345.153.345.341a.343.343 0 0 1-.345.341zm-1.377-5.221a.355.355 0 0 1-.347-.354.926.926 0 0 0-.924-.921.355.355 0 1 1 0-.709c.902.002 1.634.73 1.635 1.63a.353.353 0 0 1-.364.354"
				/>
				<path
					fill="#FFF"
					d="M13.852 18.492a.354.354 0 0 1-.354-.346v-3.817c0-.19.162-.345.362-.345s.362.154.362.345v3.817a.34.34 0 0 1-.109.247.37.37 0 0 1-.261.099M14.505 23a2.543 2.543 0 0 1-2.545-2.536.35.35 0 0 1 .702 0 1.84 1.84 0 0 0 1.843 1.837.35.35 0 1 1 0 .699"
				/>
				<path
					fill="#FFF"
					d="M12.322 20.926a.354.354 0 0 1-.362-.346v-5.53c0-.19.162-.345.362-.345s.362.155.362.346v5.53a.34.34 0 0 1-.106.244.37.37 0 0 1-.256.101"
				/>
				<path
					fill="#DF1B12"
					d="M10.287 9.82c0-.19.152-.345.339-.345s.338.154.338.345a.82.82 0 0 1-.814.828.82.82 0 0 1-.815-.828c0-.19.152-.345.339-.345s.338.154.338.345c0 .077.062.14.138.14a.14.14 0 0 0 .137-.14m2.987 0c0-.19.151-.345.338-.345s.339.154.339.345a.82.82 0 0 1-.815.828.82.82 0 0 1-.814-.828c0-.19.151-.345.338-.345s.339.154.339.345c0 .077.061.14.137.14a.14.14 0 0 0 .138-.14m1.76-5.446.184.09c.485.234.854.387 1 .411.396.067.617-.027.653-.225.034-.187-.144-.347-.549-.413-.153-.025-.562.001-1.109.068q-.123.014-.252.032zm-1.175-.582a30 30 0 0 1 1.271-.186c.62-.075 1.06-.103 1.303-.063.74.12 1.241.57 1.12 1.235-.12.655-.725.912-1.449.791-.236-.039-.633-.204-1.184-.47l-.19-.093a32 32 0 0 1-1.046-.544.35.35 0 0 1-.182-.366.35.35 0 0 1 .288-.292z"
				/>
				<path
					fill="#DF1B12"
					d="M13.163 3.077a16 16 0 0 0-.137-.383c-.125-.331-.23-.568-.296-.658-.234-.328-.45-.415-.6-.307-.161.115-.151.342.08.668.078.111.342.349.72.648l.302.235zm.42 1.31a32 32 0 0 1-1.089-.816c-.433-.344-.723-.604-.854-.789-.418-.59-.446-1.22.08-1.599.534-.384 1.149-.134 1.577.465.111.155.233.426.378.813q.069.186.144.4a28 28 0 0 1 .39 1.224.337.337 0 0 1-.238.418.35.35 0 0 1-.314-.063z"
				/>
			</g>
		</svg>
	);
}
